import { render, staticRenderFns } from "./NextPeriodBox.vue?vue&type=template&id=0a52da2a&scoped=true&"
import script from "./NextPeriodBox.vue?vue&type=script&lang=js&"
export * from "./NextPeriodBox.vue?vue&type=script&lang=js&"
import style0 from "./NextPeriodBox.vue?vue&type=style&index=0&id=0a52da2a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0a52da2a",
  null
  
)

export default component.exports